import React from "react";

const PanelCloseIcon = ({ direction = "left", ...props }) => {
  const transform = direction === "right" ? "scaleX(-1)" : undefined;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform, ...props.style }}
      {...props}>
      <mask
        id="mask0_10762_18563"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#606060" />
      </mask>
      <g mask="url(#mask0_10762_18563)">
        <path
          d="M4 18H2V6H4V18ZM12 18L6 12L12 6L13.4 7.4L9.825 11H22V13H9.825L13.425 16.6L12 18Z"
          fill="currentColor"
          fillOpacity="0.56"
        />
      </g>
    </svg>
  );
};

export default PanelCloseIcon;
